import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ProjectResponsiblerWidget from '../../../widgets/projectProposal/ProjectResponsibler/ProjectResponsiblerWidget'
import ProjectGranteeWidget from '../../../widgets/projectProposal/ProjectGrantee/ProjectGranteeWidget'
import {
  getFormProjectResponsibler,
  getFormProjectResponsiblerAndGrantee,
} from '../../../redux/actions/subProjectProposal'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID, TEMP_FORM_ID } from '../../../constants/constants'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import { getSettingFormProjectResponsiblerAndGranteePreView } from '../../../redux/actions/subProjectFormSetting'

export default function ProjectResponsibler(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const [responsiblerSchema, setResponsiblerSchema] = useState()
  const [isSameGrantee, setIsSameGrantee] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    // setSchema(mockSchema)
    if (mode == 'preView' && formId) {
      handleGetSchemaPreView()
    } else if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // let _schema = cloneDeep(mockSchema) //await getProjectName(proposalId)
      let _schema = await getFormProjectResponsiblerAndGrantee(subProjectId)

      setSchema(_schema)
      setIsEditWidget({
        projectResponsibler: _schema.forms?.projectResponsibler?.id ? false : true,
        projectGrantor: _schema.forms?.projectGrantor?.id ? false : true,
      })

      setIsSameGrantee(_schema?.forms?.projectResponsibler?.sameGrantee?.value?.includes('1'))

      setShowEditAll(!_schema.forms?.projectResponsibler?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPreView = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSettingFormProjectResponsiblerAndGranteePreView(formId)

      setSchema(_schema)
      setIsEditWidget({
        projectResponsibler: true,
        projectGrantor: true,
      })

      setShowEditAll(false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleReLoadResponsibler = async () => {
    startLoading()
    try {
      // let _schema = cloneDeep(mockSchema) //await getProjectName(proposalId)
      let response = await getFormProjectResponsibler(subProjectId)

      setResponsiblerSchema(response)

      handleOnChangeIsEdit('projectResponsibler', false, setIsEditWidget)
    } catch (e) {
      //console.log('error', e)
    }
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject mode={mode}>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={schema.buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}

          {schema?.forms?.projectGrantor && (
            <ProjectGranteeWidget
              showCommandButton={!schema.forms.projectGrantor.disabled}
              schema={schema.forms.projectGrantor}
              isEdit={isEditWidget.projectGrantor}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('projectGrantor', _isEdit, setIsEditWidget)
              }
              onReLoadResponsibler={isSameGrantee ? handleReLoadResponsibler : () => {}}
            />
          )}

          {schema?.forms?.projectResponsibler && (
            <ProjectResponsiblerWidget
              showCommandButton={
                responsiblerSchema
                  ? !responsiblerSchema.disabled
                  : !schema.forms.projectResponsibler.disabled
              }
              schema={responsiblerSchema ? responsiblerSchema : schema.forms.projectResponsibler}
              isEdit={isEditWidget.projectResponsibler}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('projectResponsibler', _isEdit, setIsEditWidget)
              }
              setIsSameGrantee={setIsSameGrantee}
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
